<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import "./assets/fonts/root.css";

export default {
  name: "App"
};
</script>

<style lang="scss">
* {
  outline: none !important;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}

html,
body {
  margin: 0 auto;
  padding: 0;
  max-width: 660px;
}

.SVGbox {
  display: flex;

  svg {
    margin: auto;
  }
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

button {
  border: none;
  cursor: pointer;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue